import { useCallback, useLayoutEffect, useRef } from "react"

export const useLockScroll = () => {
  let scrollPosition = useRef()

  const lockScroll = useCallback(() => {
    scrollPosition.current = window.pageYOffset
    document.body.style.background = "white"
    document.body.style.overflow = "hidden"
    document.body.style.position = "fixed"
    document.body.style.top = `-${scrollPosition.current}px`
    document.body.style.width = "100%"
    document.body.style.paddingRight = "var(--scrollbar-compensation)"
    document.body.dataset.scrollLock = "true"
  }, [])

  const unlockScroll = useCallback(() => {
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("position")
    document.body.style.removeProperty("top")
    document.body.style.removeProperty("width")
    document.body.style.removeProperty("padding-right")
    document.body.style.removeProperty("background")
    delete document.body.dataset.scrollLock
    window.scrollTo(0, scrollPosition.current)
  }, [scrollPosition])

  const addScrollbarCompensation = useCallback(() => {
    document.body.dataset.scrollLock = "true"
  }, [])

  const removeScrollbarCompensation = useCallback(() => {
    delete document.body.dataset.scrollLock
  }, [])

  useLayoutEffect(() => {
    const scrollBarCompensation = window.innerWidth - document.body.offsetWidth
    document.body.style.setProperty(
      "--scrollbar-compensation",
      `${scrollBarCompensation}px`
    )
  }, [])

  return {
    lockScroll,
    unlockScroll,
    addScrollbarCompensation,
    removeScrollbarCompensation,
  }
}
